var _defs, _path, _path2, _path3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42.008,
    height: 41.33,
    viewBox: "0 0 42.008 41.33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".map_svg__a{fill:#443a77}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "map_svg__a",
    d: "M21.167 29.732l-.423-.672c-.371-.59-9.081-14.5-9.081-19.556a9.504 9.504 0 0119.008 0c0 5.059-8.71 18.966-9.081 19.556zm0-28.732a8.513 8.513 0 00-8.5 8.5c0 4.165 6.73 15.439 8.5 18.338 1.773-2.9 8.5-14.173 8.5-18.338a8.514 8.514 0 00-8.5-8.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "map_svg__a",
    d: "M21.167 15.618a5.947 5.947 0 115.947-5.949 5.954 5.954 0 01-5.947 5.949zm0-10.895a4.947 4.947 0 104.947 4.946 4.953 4.953 0 00-4.947-4.946zM30.824 41.33a.493.493 0 01-.269-.079.5.5 0 01-.231-.421V21.002a.5.5 0 01.29-.454l10.684-4.945a.5.5 0 01.71.454v19.828a.5.5 0 01-.29.454l-10.684 4.945a.5.5 0 01-.21.046zm.5-20.009v18.727l9.684-4.483V16.839zM11.183 41.33a.5.5 0 01-.255-.07.5.5 0 01-.245-.43V21.002a.5.5 0 01.279-.448l4.352-2.156.444.9-4.075 2.018v18.679l9.247-4.983.474.881-9.983 5.381a.5.5 0 01-.238.056z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "map_svg__a",
    d: "M11.183 41.33a.5.5 0 01-.21-.046L.29 36.339a.5.5 0 01-.29-.454V16.057a.5.5 0 01.71-.454l10.683 4.945a.5.5 0 01.29.454V40.83a.5.5 0 01-.5.5zM1 35.569l9.683 4.483V21.321L1 16.839zM30.824 41.33a.5.5 0 01-.243-.063l-9.657-5.381a.5.5 0 01-.257-.437v-6.656h1v6.362l8.657 4.824V21.321l-3.855-1.784.419-.908 4.146 1.919a.5.5 0 01.29.454V40.83a.5.5 0 01-.5.5z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMap);
export default __webpack_public_path__ + "static/media/map.f062a8fdbbe11f62c1e5427c3091f2ce.svg";
export { ForwardRef as ReactComponent };